import { render, staticRenderFns } from "./AclModulos.vue?vue&type=template&id=02f32869&scoped=true&"
import script from "./AclModulos.vue?vue&type=script&lang=js&"
export * from "./AclModulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f32869",
  null
  
)

export default component.exports